/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum TracciatoSorgenteTypes {
    ORDINI = 0,
    CONTENITORI_MATERIALE = 1,
    CONTENITORI_PRODOTTO = 2,
    CAUSALI = 3,
    INVENTARIO = 4,
    ANAGRAFICHE = 5,
    ORDINI_VENDITA = 6,
    NC_CODICI = 7,
    ORDINI_SPEDIZIONE = 8,
    OPERATORI = 9,
    OPERATORI_BADGE = 10,
}
